export default "__VITE_ASSET__31f92c10__"